import { atom, useAtomValue, useSetAtom } from 'jotai';
import { FicheDePrep, Sequence } from 'types/sequences';

interface Payload {
  onSelectFicheDePrep?: ({
    ficheDePrepId,
    sequenceId,
    doNotPrefill,
  }: {
    sequenceId?: string;
    ficheDePrepId: string;
    doNotPrefill?: boolean;
  }) => Promise<FicheDePrep>;
  onSelectSequence?: (sequenceId: string) => Promise<Sequence>;
  callback?: (ficheDePrep: FicheDePrep) => void;
  selectableType: 'fdp' | 'sequence';
  isOpen: boolean;
  callout?: string;
  withBackdrop?: boolean;
  title?: string;
}

const payload = atom<Payload>({
  isOpen: false,
  selectableType: 'fdp',
});

const setOnSelectFicheDePrepAtom = atom(
  null,
  (
    get,
    set,
    onSelectFicheDePrep: ({
      ficheDePrepId,
      sequenceId,
      doNotPrefill,
    }: {
      sequenceId?: string;
      ficheDePrepId: string;
      doNotPrefill?: boolean;
    }) => Promise<any>,
  ) => set(payload, { ...get(payload), onSelectFicheDePrep }),
);

export const useSetOnSelectFicheDePrep = () =>
  useSetAtom(setOnSelectFicheDePrepAtom);

const isOpenAtom = atom(get => get(payload).isOpen);
export const useIsFicheDePrepDrawerOpen = () =>
  useAtomValue<boolean>(isOpenAtom);

export const useFicheDePrepPayload = () => useAtomValue(payload);
export const useSetFicheDePrepPayload = () => useSetAtom(payload);
const close = atom(null, (get, set) =>
  set(payload, { isOpen: false, selectableType: 'fdp' }),
);
const open = atom(null, (get, set, params?: Payload) => {
  if (params) {
    set(payload, { ...get(payload), ...params });
  }
  set(payload, { ...get(payload), isOpen: true });
});
export const useCloseFicheDePrepDrawer = () => useSetAtom(close);
export const useOpenFicheDePrepDrawer = () => useSetAtom(open);
